import '../css/main.css';
import {pageReady,inViewport,onClick} from './abstract/helpers.js';
import {ResponsiveMenu} from './components/responsive-menu.js';
import {GlideSlider} from './components/glide-slider.js';
import {CustomSelect} from './components/custom-select.js';
import {ReplacePageContent} from './archives/replace-page-content';
import {Notifications} from './components/notifications.js';
import {FollowMenu} from './components/follow-menu-style-1.js';
import {HoverPopups} from './components/hover-popups.js';
import {SearchPopup} from './components/search-popups.js';
import {SelectMenu} from './components/select-menu-style-1.js';
import {Funding} from './components/funding.js';
import {Popup} from './components/popup.js';
import {FAQ} from './components/faq.js';
import {ImpactSlider} from './components/impact-slider.js';
import {HeaderSlider} from './components/header-slider.js';
import {FormResetButton} from './components/form-reset-button.js';
import {Menu} from './components/menu.js';
import {LocationMap} from './components/location-map.js';
import {ScrollClass} from './components/scroll-class.js';
import {OpenLoginPopup} from './components/open-login-popup.js';




pageReady(function(){
class Init {
  constructor() {

    //responsive menu class toggle
    new ResponsiveMenu();
    new Notifications();
    new CustomSelect();
    new ReplacePageContent();
    new HoverPopups();
    new FollowMenu();
    new SelectMenu();
    new Funding();
    new ImpactSlider();
    new FAQ();
    new HeaderSlider();
    new Menu();
    new SearchPopup();
    new FormResetButton();
    new Popup();
    new LocationMap();
    new OpenLoginPopup();
    new ScrollClass();

    new GlideSlider('.hero-glide',{
      type: 'carousel',
      perView: 1,
      autoplay: 4000,
    });
  
    if(window.matchMedia("screen and (min-width: 640px)").matches) {
      new GlideSlider('.event-glide',{
        type: 'carousel',
        perView: 3,
        breakpoints: {
          1024: {
            perView: 2
          },
          600: {
            perView: 1
          }
        },
        autoplay: 4000,
        gap: 24,
      });
    }

    inViewport('.animated-circle',(e) => {
      if(e) {
        document.querySelector('.animated-circle').classList.add('start');
      }
    });

    inViewport('.animated-circle-2',(e) => {
      if(e) {
        document.querySelector('.animated-circle-2').classList.add('start');
      }
    });

    inViewport('.animated-circle-3',(e) => {
      if(e) {
        document.querySelector('.animated-circle-3').classList.add('start');
      }
    });

    inViewport('.animated-circle-4',(e) => {
      if(e) {
        document.querySelector('.animated-circle-4').classList.add('start');
      }
    });

    inViewport('.animated-circle-5',(e) => {
      if(e) {
        document.querySelector('.animated-circle-5').classList.add('start');
      }
    });

    inViewport('.animated-oval',(e) => {
      if(e) {
        document.querySelector('.animated-oval').classList.add('start');
      }
    });


    onClick(document.querySelector('#copy'),(e) => {
      if(e) {
        e.preventDefault();
        var dummy = document.createElement('input'),
        text = window.location.href;

        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);

        document.querySelector('#copy span').innerHTML = 'Copied!';
      }
    });
    

    document.querySelector("body").classList.remove("no-transition");


  }
}

new Init();

});

